export default __webpack_public_path__ + "static/media/queenatlantis4.c0dff920.jpg";